import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { fetchCurrentSubscription } from "../../store/subscription/actions"
import { useAuth } from "../../hooks/useAuth"

const Badge = ({ bgColor, icon, text }) => (
  <Link to="/subscription/details" style={{ textDecoration: "none" }}>
    <span
      className="d-inline-flex align-items-center gap-1 rounded-3 px-3 py-1"
      style={{
        backgroundColor: bgColor,
        color: "#fff",
        fontSize: "12px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        cursor: "pointer",
        transition: "filter .2s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
    >
      <i className={`bx ${icon}`} style={{ fontSize: 14 }} />
      {text}
    </span>
  </Link>
)

const SubscriptionBanner = () => {
  const dispatch = useDispatch()
  const { currentStatus } = useSelector((state) => state.subscription)
  const { roles } = useAuth()

  useEffect(() => {
    dispatch(fetchCurrentSubscription())
  }, [dispatch])

  if (roles.includes("ROLE_SUPER_ADMIN")) return null
  if (!currentStatus) return null

  const {
    status, daysRemaining, planName, planTrialName, planTrialDaysRemaining,
  } = currentStatus

  const badges = []

  // Firma düzeyinde "deneme" artık yok; tek deneme, Ücretsiz'deki firmanın 14 günlük paket denemesi.
  if (planTrialName) {
    const days = planTrialDaysRemaining ?? 0
    const bgColor = days <= 3 ? "#dc3545" : days <= 7 ? "#E56A22" : "#F2C96D"
    const icon = days <= 3 ? "bx-error" : "bx-time-five"
    badges.push({ bgColor, icon, text: `${planTrialName} denemesi: ${days} gün` })
  } else if (status === "ACTIVE") {
    if (daysRemaining <= 30) {
      const bgColor = daysRemaining <= 7 ? "#dc3545" : "#E56A22"
      const icon = daysRemaining <= 7 ? "bx-error" : "bx-package"
      badges.push({ bgColor, icon, text: `${planName || "Paket"}: ${daysRemaining} gün` })
    }
  } else if (status === "EXPIRED") {
    badges.push({
      bgColor: "#dc3545",
      icon: "bx-error",
      text: planName ? "Paket süreniz dolmuştur" : "Aktif paketiniz bulunmuyor",
    })
  }

  // Limit uyarıları burada değil; header'da bildirim zilinin solundaki ikonda (PlanLimitIndicator).
  if (badges.length === 0) return null

  return (
    <div className="d-none d-lg-inline-flex align-items-center gap-2 flex-wrap ms-1">
      {badges.map((b, i) => <Badge key={i} {...b} />)}
    </div>
  )
}

export default SubscriptionBanner
